var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02 14L6.185 9.05V8.39H6.515C7.045 8.39 7.49 8.34 7.85 8.24C8.22 8.14 8.51 7.975 8.72 7.745C8.93 7.515 9.055 7.2 9.095 6.8H6.185V5.84H9.08C9.01 5.47 8.87 5.17 8.66 4.94C8.45 4.7 8.165 4.525 7.805 4.415C7.455 4.305 7.025 4.25 6.515 4.25H6.185V3.29H12.395V4.25H9.56C9.79 4.44 9.98 4.665 10.13 4.925C10.28 5.185 10.375 5.49 10.415 5.84H12.395V6.8H10.445C10.375 7.53 10.095 8.1 9.605 8.51C9.125 8.91 8.485 9.165 7.685 9.275L10.55 14H9.02Z",
    fill: "#341439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.30ae7001d16d0f3612c7a4063feaa793.svg";
export { ForwardRef as ReactComponent };